module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?def9a54f78be2b5d1e7842ada488fa76";